import { Link } from "react-router-dom";

const ThriverProfileLink = ({
  user,
  underline = false,
  showIfNotThriver = false,
  children,
  redirectToSpecificSection = ''
}) => {
  const identifier = user?.identifier || user?.id;
  const { type } = user;

  return type !== "thriver" ? (
    showIfNotThriver ? (
      children
    ) : null
  ) : (
    <Link
      title="Thriver profile"
      to={{
        pathname: `/user-preview`,
        hash: redirectToSpecificSection ? `#${redirectToSpecificSection}` : '',
        state: { userId: identifier },
      }}
      className={`link-dark${underline ? "-underlined" : ""}`}
      style={{ width: "auto", display: "inline-block" }}
    >
      {children}
    </Link>
  );
};

export default ThriverProfileLink;
